// This file applies to API-V2, Dev-Center-API-V2, and all Frontend APPs
const isShutDown = (tenantId) => {
  if (['tyson-louths-demo-winery'].includes(tenantId)) {
    return true;
  }
  return false;
};

const getShutdownWindow = () => ({
  startTime: '2023-04-13T05:00:00.000Z',
  endTime: '2023-04-13T11:00:00.000Z' // 4:00am PST
});

const isNickname = (tenantId) => {
  if (
    [
      'development',
      'opus-one-winery',
      'chappellet-winery',
      'chappellet-uat',
      'chappellet-winery-dev',
      'chappellet-winery-qa'
    ].includes(tenantId)
  ) {
    return true;
  }
  return false;
};

const isPacificUnion = (tenantId) => {
  if (
    [
      'promontory',
      'promontory-testing',
      'promontory-production',
      'bond',
      'bond-production',
      'bond-testing',
      'harlan-estate',
      'harlan-estate-production',
      'the-mascot',
      'the-mascot-production'
    ].includes(tenantId)
  ) {
    return true;
  }
  return false;
};

export { getShutdownWindow, isNickname, isPacificUnion, isShutDown };
